import { comments } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            读者评论
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            来自吃瓜群众的真实声音
          </p>
        </div>

        <div className="space-y-5">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/60 p-5 md:p-6"
            >
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-11 h-11 rounded-full bg-accent-100 flex items-center justify-center">
                  <span className="text-sm font-bold text-accent-600">{comment.avatar}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                      {comment.name}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">
                      {comment.time}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                    {comment.content}
                  </p>
                  <div className="flex items-center gap-4">
                    <div className="flex items-center gap-1.5 text-xs text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors">
                      <i className="ri-thumb-up-line"></i>
                      <span>{comment.likes}</span>
                    </div>
                    <div className="flex items-center gap-1.5 text-xs text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors">
                      <i className="ri-chat-1-line"></i>
                      <span>回复</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}